import { locateProxy } from '#~/agent/index.js';
import type { ZoomTo } from './types.js';
import type { DeepPartial } from '@tryiris-ai/common.protojs';
import {
  CommandDeviceEnhancedMove, // ControlDeviceMovementEnhancedZoom
  CommandDeviceMove
} from '@tryiris-ai/common.protojs/agent/v1/agent';
import { throttle } from 'lodash-es';
import { isTrialCameraLocked } from '#~/api/billing/camera-access.js';

/**
 * Enhacned zoom the specified device.
 *
 * @param deviceId - The ID of the device to be moved.
 * @param params - Zoom intent.
 */
const zoomTo_: ZoomTo = (deviceId, { pos, zoom, operation, panTilt }) => {
  const proxy = locateProxy(deviceId);

  if (!proxy) {
    return;
  }
  // Check inside the throttled callback, after any expiry while it was queued.
  if (isTrialCameraLocked(proxy.roomId, proxy.id, deviceId)) return;

  {
    // const control: DeepPartial<ControlDeviceMovementEnhancedZoom> = {
    //   centerX: pos.x,
    //   centerY: pos.y,
    //   zoomSpeed: zoom === 0 ? undefined : zoom
    // };
    // void proxy.mutate(
    //   {
    //     control: {
    //       device: {
    //         [deviceId]: {
    //           movement: {
    //             enhancedZoom: control
    //           }
    //         }
    //       }
    //     }
    //   },
    //   {}
    // );
  }

  {
    const OLD_TOOL = false;

    if (OLD_TOOL) {
      const moveMutation: DeepPartial<CommandDeviceMove> = {
        panTilt,
        zoom: { zoom },
        id: deviceId
      };
      proxy.connection.publish(
        `direct.authenticated.${proxy.id}.move`,
        CommandDeviceMove.encode(CommandDeviceMove.fromJSON(moveMutation)).finish()
      );

      return;
    }

    const mutation: DeepPartial<CommandDeviceEnhancedMove> = {
      id: deviceId,
      centerX: pos.x,
      centerY: pos.y,
      panTilt,
      zoom: operation === 'zoom' ? { zoom } : undefined
    };

    const mutB = CommandDeviceEnhancedMove.encode(
      CommandDeviceEnhancedMove.fromJSON(mutation)
    ).finish();
    proxy.connection.publish(`direct.authenticated.${proxy.id}.enhanced_move`, mutB);
  }
};

export const zoomTo = throttle(zoomTo_, 1000 / 6, { leading: true, trailing: true });
